import type { FunctionComponent } from 'react';
import PersonaDetailsDialog from '../../components/organisms/PersonaDetailsDialog';
import type { Persona } from '../../data/Personas';

export interface Props {
	persona: Persona;
	onBack: () => void;
}

const PersonaDetailsScreen: FunctionComponent<Props> = (props: Props) => {
	const { persona, onBack } = props;
	return <PersonaDetailsDialog persona={persona} onClose={onBack} />;
};

export default PersonaDetailsScreen;
